import {useQuery} from "@apollo/client";
import {useState, useEffect, useMemo} from "react";
import {
    BagType,
    BagListResponse,
    GET_BAG_LISTING,
    BagFiltersType
} from "../graphql/queries/getBagListing";

interface BagQueryResult {
    bagData: BagType[];
    loading: boolean;
    refetch: (variables?: any) => void;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useBagQuery = (
    filters: BagFiltersType,
    warehouseId: string | null,
    currentPage: number,
    pageSize: number
): BagQueryResult => {
    const [bagData, setBagData] = useState<BagType[]>([]);
    const [loading, setLoading] = useState(true);
    
    // 构建GraphQL查询参数 - 使用useMemo确保只在依赖变化时重新创建，触发Apollo重新查询
    const queryVariables = useMemo(() => ({
        filters: {...filters, warehouseId: warehouseId || '0'},
        pageRequest: {
            page: currentPage,
            size: pageSize,
            sortBy: "id",
            sortDirection: "DESC"
        }
    }), [filters, warehouseId, currentPage, pageSize]);

    const { data, loading: queryLoading, refetch } = useQuery<BagListResponse>(
        GET_BAG_LISTING,
        {
            variables: queryVariables,
            fetchPolicy: 'cache-and-network', // 使用cache-and-network，既能利用缓存，也能在variables变化时重新查询
            skip: !warehouseId,
            notifyOnNetworkStatusChange: true // 确保网络状态变化时更新
        }
    );
    
    // 构建查询变量的函数（用于外部refetch）
    const buildQueryVariables = () => queryVariables;

    // 当查询变量变化时，确保数据更新
    useEffect(() => {
        setLoading(queryLoading);
        if (data?.getBagListing) {
            setBagData(data.getBagListing.content || []);
        }
    }, [data, queryLoading]);

    const totalElements = data?.getBagListing?.totalElements || 0;

    return {
        bagData,
        loading,
        refetch,
        totalElements,
        buildQueryVariables
    };
};
